import { render, staticRenderFns } from "./MessagesHeader.vue?vue&type=template&id=329e3560"
import script from "./MessagesHeader.vue?vue&type=script&lang=js"
export * from "./MessagesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports